<template>
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryParams" class="user-search">
        <el-form-item label="菜单名称">
          <el-input
            v-model.trim="queryParams.menuName"
            placeholder="请输入菜单名称"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            v-model="queryParams.status"
            placeholder="请搜索状态"
            clearable
          >
            <el-option label="正常" value="0" />
            <el-option label="停用" value="1" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="handleQuery"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="resetQuery"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="handleAdd"
          >新增</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="info"
          icon="el-icon-sort"
          @click="toggleExpand"
          >{{ isExpandAll ? "折叠" : "展开" }}</el-button
        >
      </div>
    </div>

    <div class="main-table">
      <el-table
        v-if="refreshTable"
        v-loading="loading"
        :data="menuList"
        row-key="menuId"
        :default-expand-all="isExpandAll"
        :tree-props="{ children: 'children' }"
        stripe
        size="small"
        header-cell-class-name="table-header"
        element-loading-text="拼命加载中"
        style="width: 100%;"
      >
        <el-table-column
          prop="menuName"
          label="菜单名称"
          min-width="180"
          show-overflow-tooltip
        />
        <!-- <el-table-column prop="icon" label="图标" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.icon || "-" }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="menuType" label="类型" align="center" width="80">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="
                scope.row.menuType === 'M'
                  ? ''
                  : scope.row.menuType === 'C'
                  ? 'success'
                  : 'warning'
              "
            >
              {{
                scope.row.menuType === "M"
                  ? "目录"
                  : scope.row.menuType === "C"
                  ? "菜单"
                  : "按钮"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="排序"
          align="center"
          width="70"
        />
        <el-table-column
          prop="perms"
          label="权限标识"
          min-width="160"
          show-overflow-tooltip
        />
        <el-table-column
          prop="component"
          label="组件路径"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column prop="status" label="状态" align="center" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '0' ? 'success' : 'info'">
              {{ scope.row.status === "0" ? "正常" : "停用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="160"
        />
        <el-table-column label="操作" align="center" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button
              plain
              round
              type="warning"
              size="small"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >修改</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="primary"
              icon="el-icon-plus"
              @click="handleAddChild(scope.row)"
              >新增</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="danger"
              icon="el-icon-delete"
              class="danger-text"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <MenuForm ref="formRef" @success="handleSuccess" />
  </div>
</template>

<script>
import { menuList, menuDelete } from "@/api/system/menu";
import { buildMenuTree } from "@/utils/dynamicMenu";
import MenuForm from "./MenuForm.vue";

function filterMenuTree(list, query) {
  const name = (query.menuName || "").trim();
  const status = query.status;

  return (list || []).reduce((acc, item) => {
    const children = item.children ? filterMenuTree(item.children, query) : [];
    const nameMatch = !name || (item.menuName && item.menuName.includes(name));
    const statusMatch =
      status === "" || status == null || item.status === status;

    if ((nameMatch && statusMatch) || children.length) {
      acc.push({
        ...item,
        children: children.length ? children : undefined
      });
    }
    return acc;
  }, []);
}

export default {
  name: "MenuManage",
  components: {
    MenuForm
  },
  data() {
    return {
      loading: false,
      refreshTable: true,
      isExpandAll: true,
      menuTree: [],
      menuList: [],
      queryParams: {
        menuName: "",
        status: ""
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await menuList();
        this.menuTree = buildMenuTree(res.data || []);
        this.menuList = filterMenuTree(this.menuTree, this.queryParams);
      } catch (e) {
        this.$message.error("菜单列表加载失败");
      } finally {
        this.loading = false;
      }
    },
    handleQuery() {
      this.getList();
    },
    resetQuery() {
      this.queryParams = {
        menuName: "",
        status: ""
      };
      this.menuList = this.menuTree;
    },
    toggleExpand() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },
    handleAdd() {
      this.$refs.formRef.open("add");
    },
    handleAddChild(row) {
      this.$refs.formRef.open("addChild", row);
    },
    handleEdit(row) {
      this.$refs.formRef.open("edit", row);
    },
    async handleDelete(row) {
      try {
        await this.$confirm(
          `是否确认删除名称为「${row.menuName}」的菜单？`,
          "提示",
          { type: "warning" }
        );
      } catch (e) {
        return;
      }
      try {
        await menuDelete(row.menuId);
        this.$message.success("删除成功");
        this.handleSuccess();
      } catch (e) {
        // axios 拦截器已提示
      }
    },
    handleSuccess() {
      this.getList();
      this.$root.Bus.$emit("menu-updated");
    }
  }
};
</script>

<style scoped>
.danger-text {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/views/system/Menu/index.vue